import React, { ReactElement } from 'react';
import Link from 'next/link';

const Head = (): ReactElement => {
  return (
    <section className="freight-forwarder__head">
      <div className="freight-forwarder__head-image-box">
        <img
          className="freight-forwarder__head-image"
          src="/images/pages/Resources/FreightForwarder/head-map.png"
          alt="Logistics & Freight Map"
        />
      </div>

      <div className="container">
        <div className="freight-forwarder__head-content">
          <div className="freight-forwarder__head-description-box">
            <h1 className="freight-forwarder__head-title">How to Become a Freight Forwarder</h1>
            <p className="freight-forwarder__head-text">
              Find the requirements to become a freight forwarding member of the DF Alliance network and boost your
              logistic capabilities by using our digital freight forwarding tools.
            </p>

            <div className="new-header-hero__links-box">
              <Link className="new-link-block full" href="/membership">
                Register
              </Link>
              <Link className="new-link arrow" href="/company/contact-us">
                Show more
                <svg className="link-arrow directionRight" viewBox="0 0 10 10" aria-hidden="true">
                  <path className="link-arrow__line" d="M1 5h7" />
                  <path className="link-arrow__tip" d="M2 1l4 4-4 4" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Head;
